import { ErrorHandingInterceptor } from './interceptors/ErrorHandingInterceptor';
import { NgModule } from '@angular/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from './api/api.service';
import { CompaniesEndpoint } from './api/v0/CompaniesEndpoint';
import { MeEndpoint } from './api/v0/MeEndpoint';
import { MeAccessTokenEndpoint } from './api/v0/MeAccessTokenEndpoint';
import { AccessTokenInterceptor } from './interceptors/AccessTokenInterceptor';
import { LoadingHTTPRequestInterceptor } from './interceptors/LoadingHTTPRequestInterceptor';
import {
  API_SERVICE_CONFIG,
  createApiServiceConfig,
} from './api/ApiServiceConfig';
import { LabelsEndpoint } from './api/v0/LabelsEndpoint';
import { UsersEndpoint } from './api/v0/UsersEndpoint';
import { TicketsSupportMultimachineEndpoint } from './api/v0/TicketsSupportMultimachineEndpoint';
import { TicketsSupportAnomalyEndpoint } from './api/v0/TicketsSupportAnomalyEndpoint';
import { TicketsSupportStatusesEndpoint } from './api/v0/TicketsSupportStatusesEndpoint';
import { PartsEndpoint } from './api/v0/PartsEndpoint';
import { UploadEndpoint } from './api/v0/UploadEndpoint';
import { ReportEndpoint } from './api/v0/ReportEndpoint';
import { PermissionsEndpoint } from './api/v0/PermissionsEndpoint';
import { UserPartsEndpoint } from './api/v0/UserPartsEndpoint';
import { PasswordEndpoint } from './api/v0/PasswordEndpoint';
import { AnomaliesEndpoint } from './api/v0/AnomaliesEndpoint';
import { UsersPermissionsEndpoint } from './api/v0/UsersPermissionsEndpoint';
import { RolesEndpoint } from './api/v0/RolesEndpoint';
import { UsersRolesEndpoint } from './api/v0/UsersRolesEndpoint';
import { WorkPeriodEndpoint } from './api/v0/WorkPeriodEndpoint';
import { WorkPeriodAssigneeEndpoint } from './api/v0/WorkPeriodAssigneeEndpoint';
import { TicketsSupportMultimachineAssigneeEndpoint } from './api/v0/TicketsSupportMultimachineAssigneeEndpoint';
import { TravelEndpoint } from './api/v0/TravelEndpoint';
import { TravelAssigneeEndpoint } from './api/v0/TravelAssigneeEndpoint';
import { TicketsSupportContactEndpoint } from './api/v0/TicketsSupportContactEndpoint';
import { CompanyAssigneeEndpoint } from './api/v0/CompanyAssigneeEndpoint';
import { environment } from '../../../environments/environment';
import { CustomApplicationReferrerInterceptor } from '@fullyops/legacy/data/interceptors/CustomApplicationReferrerInterceptor';
import { VersionCheckInterceptor } from '@fullyops/core/interceptors/version-check.interceptor';
import { ContactsEndpoint } from './api/v0/ContactsEndpoint';
import { SessionExpirationInterceptor } from '@fullyops/core/interceptors/session-expiration.interceptor';

const apiServiceConfig = () => {
  return createApiServiceConfig(environment.apiUrl);
};

@NgModule({
  imports: [],
  providers: [
    // { provide: HTTP_INTERCEPTORS, useClass: CsrfInterceptor, multi: true },
    // { provide: HTTP_INTERCEPTORS, useClass: RefreshTokenInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AccessTokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SessionExpirationInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandingInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingHTTPRequestInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomApplicationReferrerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: VersionCheckInterceptor,
      multi: true,
    },
    { provide: API_SERVICE_CONFIG, useFactory: apiServiceConfig },
    CookieService,
    ApiService,
    LabelsEndpoint,
    PartsEndpoint,
    CompaniesEndpoint,
    ContactsEndpoint,
    TicketsSupportMultimachineEndpoint,
    TicketsSupportAnomalyEndpoint,
    TicketsSupportStatusesEndpoint,
    UsersEndpoint,
    MeEndpoint,
    UploadEndpoint,
    ReportEndpoint,
    MeAccessTokenEndpoint,
    PermissionsEndpoint,
    UsersRolesEndpoint,
    UsersPermissionsEndpoint,
    RolesEndpoint,
    UserPartsEndpoint,
    PasswordEndpoint,
    AnomaliesEndpoint,
    WorkPeriodEndpoint,
    WorkPeriodAssigneeEndpoint,
    TicketsSupportMultimachineAssigneeEndpoint,
    TravelEndpoint,
    TravelAssigneeEndpoint,
    TicketsSupportContactEndpoint,
    CompanyAssigneeEndpoint,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class DataModule {}
